<template>
  <div class="p-30">
      <table class="table">
        <thead>
          <th>{{ $t('description') }}</th>
          <th class="text-right">{{ $t('Booked') }}</th>
          <th class="text-right">{{ $t('invoiced') }}</th>
          <th class="text-right">{{ $t('price_diff') }}</th>
          <th class="text-right">{{ $t('agreement_control') }}</th>
        </thead>
        <tbody>
          <tr class="dynamic-rows" v-for="(product, index) in data.products" :key="index">
            <td>{{ product.product_name }}</td>
            <td class="text-right">{{ (product.booked_price ? parseFloat(product.booked_price) : 0) | currency(product.currency_conversion) }}</td>
            <td class="text-right">{{ parseFloat(product.invoiced_price) | currency(product.currency_conversion) }}</td>
            <td class="text-right" :class="resolveClassByAmount(product.price_difference)">{{ product.price_difference  | currency(product.currency_conversion) }}</td>
            <td class="text-right" :class="resolveClassByAmount(product.agreement_control)">{{ product.agreement_control | currency(product.currency_conversion) }}</td>
          </tr>
          <tr>
            <td colspan="5" class="hr-row">
              <hr />
            </td>
          </tr>
          <tr>
            <td>{{ $t('weight') }}</td>
            <td class="text-right">{{ data.booked_weight !== '-' ? `${parseFloat(data.booked_weight).toFixed(2)} kg` : '-' }}</td>
            <td class="text-right">{{ data.invoiced_weight !== '-' ? `${parseFloat(data.invoiced_weight).toFixed(2)} kg` : '-'  }}</td>
            <td class="text-right" :class="data.weight_css_class">{{ data.weight_difference !== '-' ? `${parseFloat(data.weight_difference).toFixed(2)} kg` : '-' }}</td>
            <td class="text-right">-</td>
          </tr>
          <tr>
            <td>{{ $t('dimensions') }}</td>
            <td class="text-right">{{ data.booked_dimensions !== '-' ? `${data.booked_dimensions} cm` : '-' }}</td>
            <td class="text-right">{{ data.invoiced_dimensions  !== '-' ? `${data.invoiced_dimensions} cm` : '-' }}</td>
            <td class="text-right">
              <span v-if="data.length_difference !== null && data.weight_difference !== null && data.width_difference !== null">
              <span :class="data.length_css_class">{{ data.length_difference }}</span> x
              <span :class="data.width_css_class">{{ data.width_difference }}</span> x
              <span :class="data.height_css_class">{{ data.height_difference }}</span> cm
              </span>
              <span v-else>-</span>
            </td>
            <td class="text-right">-</td>
          </tr>
          <tr>
            <td>LDM</td>
            <td class="text-right">{{ data.booked_ldm !== '-' ? parseFloat(data.booked_ldm).toFixed(4) : '-' }}</td>
            <td class="text-right">{{ data.invoiced_ldm !== '-' ? parseFloat(data.invoiced_ldm).toFixed(4) : '-' }}</td>
            <td class="text-right" :class="data.ldm_css_class">{{ data.ldm_difference !== '-' ? parseFloat(data.ldm_difference).toFixed(4) : '-' }}</td>
            <td class="text-right">-</td>
          </tr>
          <tr>
            <td>{{ $t('volume') }}</td>
            <td class="text-right">{{ data.booked_volume !== '-' ? `${parseFloat(data.booked_volume).toFixed(4)} cbm` : '-' }}</td>
            <td class="text-right">{{ data.invoiced_volume !== '-' ? `${parseFloat(data.invoiced_volume).toFixed(4)} cbm` : '-' }}</td>
            <td class="text-right" :class="data.volume_css_class">{{ data.volume_difference !== '-' ? `${parseFloat(data.volume_difference).toFixed(4)} cbm` : '-' }}</td>
            <td class="text-right">-</td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
export default {
  name: 'invoiceDetailView',
  props: ['data'],
  methods: {
    resolveClassByAmount(amount) {
      if (amount < 0) {
        return 'text-warning';
      }
      if (amount > 0) {
        return 'text-error';
      }
      if (amount === 0) {
        return 'text-success';
      }
      return ''
    },
  },
}
</script>

<style scoped>
  table th {
    text-align: left;
    padding: 5px 0;
    font-weight: 500;
  }
  .text-right {
    text-align: right;
  }
  table td {
    padding: 5px 0;
    color: #989FA6;
  }
  .hr-row {
    padding: 15px 0;
  }
</style>
